import { render, staticRenderFns } from "./UiSwitch.vue?vue&type=template&id=39bbe6ce&scoped=true"
import script from "./UiSwitch.vue?vue&type=script&lang=js"
export * from "./UiSwitch.vue?vue&type=script&lang=js"
import style0 from "./UiSwitch.vue?vue&type=style&index=0&id=39bbe6ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bbe6ce",
  null
  
)

export default component.exports